import _inheritsLoose from "@babel/runtime/helpers/esm/inheritsLoose";
import React from "react";
import Image from "gatsby-image";
import Layout from "../../layouts";
import Header from "../../components/header";
import Callout from "../../components/callout";
import Contact from "../../components/contact";
import iconPricing from "../../images/icons/triple-threat.svg";
import iconMoq from "../../images/icons/moq.svg";
import iconLeadTime from "../../images/icons/lead-time.svg";
import iconCustom from "../../images/icons/niche-manufacturing.svg";
import iconCustomPackaging from "../../images/icons/cutom-packaging.svg";
var ProductPageStateProductType;
(function (ProductPageStateProductType) {
    ProductPageStateProductType["STANDARD"] = "Standard Softgels In Various Potencies";
    ProductPageStateProductType["TARGETING"] = "Targeting Blends";
})(ProductPageStateProductType || (ProductPageStateProductType = {}));
var _default = /*#__PURE__*/ function (_React$Component) {
    _inheritsLoose(_default, _React$Component);
    function _default(props) {
        var _this;
        _this = _React$Component.call(this, props) || this;
        _this.state = {
            products: [{
                    type: ProductPageStateProductType.STANDARD,
                    title: "CBD Isolate",
                    image: "IMG_5"
                }, {
                    type: ProductPageStateProductType.STANDARD,
                    title: "Broad Spectrum (THC Free)",
                    image: "IMG_7"
                }, {
                    type: ProductPageStateProductType.STANDARD,
                    title: "Full Spectrum",
                    image: "IMG_9"
                }, {
                    type: ProductPageStateProductType.STANDARD,
                    title: "Delta 8 THC",
                    image: "IMG_5"
                }, {
                    type: ProductPageStateProductType.STANDARD,
                    title: "CBN",
                    image: "IMG_8"
                }, {
                    type: ProductPageStateProductType.STANDARD,
                    title: "CBG",
                    image: "IMG_5"
                },
                {
                    type: ProductPageStateProductType.TARGETING,
                    title: "Energy Boost",
                    image: "IMG_4"
                }, {
                    type: ProductPageStateProductType.TARGETING,
                    title: "Sleep Aid"
                }, {
                    type: ProductPageStateProductType.TARGETING,
                    title: "Immune Boost",
                    image: "IMG_6"
                }, {
                    type: ProductPageStateProductType.TARGETING,
                    title: "Pain Relief"
                }, {
                    type: ProductPageStateProductType.TARGETING,
                    title: "Focus"
                }, {
                    type: ProductPageStateProductType.TARGETING,
                    title: "Calming"
                }]
        };
        return _this;
    }
    var _proto = _default.prototype;
    _proto.renderImageForProduct = function renderImageForProduct(match) {
        var PLACEHOLDER_IMAGE = "https://via.placeholder.com/250?text=Image+Coming+Soon";
        if (match.image) {
            var _this$props$data, _this$props$data$prod, _this$props$data$prod2, _this$props$data$prod3, _this$props$data$prod4;
            return /*#__PURE__*/ React.createElement(Image, {
                fluid: match.image && ((_this$props$data = this.props.data) === null || _this$props$data === void 0 ? void 0 : (_this$props$data$prod = _this$props$data.products) === null || _this$props$data$prod === void 0 ? void 0 : (_this$props$data$prod2 = _this$props$data$prod.edges) === null || _this$props$data$prod2 === void 0 ? void 0 : (_this$props$data$prod3 = _this$props$data$prod2.find(function (e) {
                    return e.node.name === match.image;
                })) === null || _this$props$data$prod3 === void 0 ? void 0 : (_this$props$data$prod4 = _this$props$data$prod3.node.childImageSharp) === null || _this$props$data$prod4 === void 0 ? void 0 : _this$props$data$prod4.fluid),
                alt: match.title
            });
        }
        return /*#__PURE__*/ React.createElement("img", {
            src: PLACEHOLDER_IMAGE,
            alt: match.title
        });
    };
    _proto.renderProductsForType = function renderProductsForType(type) {
        var _this2 = this;
        return this.state.products.filter(function (p) {
            return p.type === type;
        }).map(function (match, i) {
            return /*#__PURE__*/ React.createElement("li", {
                key: match.title + i
            }, _this2.renderImageForProduct(match), /*#__PURE__*/ React.createElement("h3", null, match.title));
        });
    };
    _proto.render = function render() {
        return /*#__PURE__*/ React.createElement(Layout, null, /*#__PURE__*/ React.createElement(Header, {
            title: "Products",
            message: "We handle a wide variety of products/blends daily. From single drop oils to complex powder emulsion suspensions, our team can help you bring your product to life! We have long-standing relations with ingredient suppliers all around the globe, giving us access to a large portfolio of unique ingredients."
        }), /*#__PURE__*/ React.createElement("section", null, /*#__PURE__*/ React.createElement("div", {
            className: "grid"
        }, /*#__PURE__*/ React.createElement(Callout, {
            title: "R&D",
            message: "We can assist in the Research and Development phases of developing a new custom formulation from scratch. We offer two levels of pre-production testing (contact for pricing).",
            titlePosition: "center",
            icon: iconCustom
        })), /*#__PURE__*/ React.createElement("div", {
            className: "grid"
        }, /*#__PURE__*/ React.createElement(Callout, {
            title: "Benchtop Formulation",
            message: "We bring in all the ingredients and perform a small-scale benchtop of the fill material only (no encapsulation). This is to test the stability of the formulation to ensure all the ingredients stay in suspension. This test also will provide insight on the color of the fill material as some customers will choose to color the shell.",
            titlePosition: "center"
        }), /*#__PURE__*/ React.createElement(Callout, {
            title: "Pilot Run",
            message: "We conduct a benchtop as explained above, but will then encapsulate the fill material to produce finished softgel samples. These pilot runs will typically yield 4-10k softgels.",
            titlePosition: "center"
        }))), /*#__PURE__*/ React.createElement("section", {
            className: "grid grid--dark"
        }, /*#__PURE__*/ React.createElement(Callout, {
            title: "Pricing",
            message: "Pricing is based on the fill material ingredients combined with the volume of those respective softgels being ordered at a given time. Price breaks are issued as order volume increases. Contact our sales team for more information.",
            titlePosition: "center",
            icon: iconPricing
        })), /*#__PURE__*/ React.createElement("section", {
            className: "grid"
        }, /*#__PURE__*/ React.createElement(Callout, {
            title: "MOQ",
            message: "Our encapsulation MOQ is 50,000 softgels per product",
            titlePosition: "center",
            icon: iconMoq
        })), /*#__PURE__*/ React.createElement("section", {
            className: "grid grid--dark"
        }, /*#__PURE__*/ React.createElement(Callout, {
            title: "Lead Time",
            message: "Lead time is dictated by ingredient procurement, testing requirements, order volume, and packaging requirements. That said, we pride ourselves on our quick turnaround. Most of our customers see finished product in 2-4 weeks from the time we\u2019ve received all ingredients.",
            titlePosition: "center",
            icon: iconLeadTime
        })), /*#__PURE__*/ React.createElement("section", {
            className: "grid"
        }, /*#__PURE__*/ React.createElement(Callout, {
            title: "Packaging",
            message: "We have a full bottling line that many of our customers and brands take advantage of due to our extremely competitive pricing. We utilize our relationships with various packaging component manufacturers and suppliers to ensure consistent price and supply. That way we can provide a reliable, consistent, fully turn-key manufacturing solution.",
            titlePosition: "center",
            icon: iconCustomPackaging
        })), /*#__PURE__*/ React.createElement(Contact, null));
    };
    return _default;
}(React.Component);
export { _default as default };
var query = "3335072137";
